// Source de vérité des couleurs de prestation (identique à la palette backend).
// 20 couleurs bien distinctes visuellement. Les anciennes couleurs enregistrées
// restent valides : on n'en supprime aucune, on affiche toujours la couleur en
// cours même si elle ne figure pas dans cette liste.
export const SERVICE_COLORS = [
  "#8b5cf6", // violet
  "#c084fc", // mauve
  "#6366f1", // indigo
  "#2563eb", // bleu roi
  "#38bdf8", // bleu clair
  "#06b6d4", // cyan
  "#14b8a6", // turquoise
  "#10b981", // vert émeraude
  "#4ade80", // vert clair
  "#6b8e23", // vert olive
  "#eab308", // jaune
  "#f59e0b", // ambre
  "#f97316", // orange
  "#ea580c", // orange foncé
  "#ef4444", // rouge
  "#7f1d1d", // bordeaux
  "#ec4899", // rose
  "#d946ef", // fuchsia
  "#92400e", // marron
  "#374151", // gris anthracite
];
